import {
  CONGRATULATIONS_MESSAGE_SENDING,
  CONGRATULATIONS_MESSAGES_DOWNLOADED,
  CONGRATULATIONS_MESSAGE_REMOVED,
  CONGRATULATIONS_MESSAGE_PENDING,
  CONGRATULATIONS_MESSAGE_FAILED,
  CONGRATULATIONS_MESSAGE_DOWNLOADED,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: null,
  sending: null,
};

// eslint-disable-next-line func-names
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONGRATULATIONS_MESSAGE_SENDING:
      return {
        ...state,
        sending: true,
      };
    case CONGRATULATIONS_MESSAGES_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case CONGRATULATIONS_MESSAGE_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case CONGRATULATIONS_MESSAGE_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    case CONGRATULATIONS_MESSAGE_DOWNLOADED: {
      const messageDownloaded = action.payload;
      let messages = [];
      let messageIndex = -1;
      if (state.content) {
        messages = [...state.content];
        messageIndex = messages.findIndex(
          (msg) => msg.id === messageDownloaded.id,
        );
      }
      if (messageIndex === -1) {
        messages.push(action.payload);
      } else {
        messages[messageIndex] = action.payload;
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: messages,
      };
    }
    case CONGRATULATIONS_MESSAGE_REMOVED: {
      const message = action.payload;
      let messages = [...state.content];
      // eslint-disable-next-line func-names
      const isMessage = (messageId) => function (element) {
        return element.id !== messageId;
      };
      messages = state.content.filter(isMessage(message.id));
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: messages,
      };
    }
    default:
      break;
  }
  return state;
}
